{
  "fr": {
    "ticket_category": {
      "Decisions": "Décision",
      "Issue": "Après-vente",
      "Regular": "Réguliers",
      "labels": {
        "ticket_category": "Type"
      }
    }
  }
}
